import {createContext, ReactEventHandler} from "react";

export type PanelContextType = {
  expanded?: boolean;
  disabled?: boolean;
  toggle?: ReactEventHandler;
  withChevron?: boolean;
  withPlusMinus?: boolean;
};

export const PanelContext = createContext<PanelContextType>({});
